import React from 'react';
import { Table } from 'antd';
import type { TableProps, TablePaginationConfig } from 'antd';
import classNames from 'classnames';

interface GenericTableProps<T> extends Omit<TableProps<T>, 'pagination'> {
  className?: string;
  dataSource: T[];
  columns: any[];
  loading?: boolean;
  pagination?: false | TablePaginationConfig;
  scroll?: { x?: number | string; y?: number | string };
}

const GenericTable = <T extends object>({
  className,
  dataSource,
  columns,
  loading = false,
  pagination = {
    current: 1,
    pageSize: 10,
    showSizeChanger: true,
    showQuickJumper: true,
  },
  scroll,
  ...rest
}: GenericTableProps<T>) => {
  const tableClasses = classNames('generic-table', className);

  return (
    <Table
      className={tableClasses}
      dataSource={dataSource}
      columns={columns}
      loading={loading}
      pagination={pagination}
      scroll={scroll}
      {...rest}
    />
  );
};

export { GenericTable };
export default GenericTable;
